import React from 'react';

import { useIntl } from 'react-intl-next';

import SearchIcon from '@atlaskit/icon/core/search';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';

import { SquareReturnIcon } from '../../../../../common/constants/icons/square-return';
import { SearchLink } from '../../../../../common/ui/search-link';
import { useInputQuery, useSearchActions } from '../../../../../controllers/store';
import { useDropdownActions } from '../../../../../controllers/store/dropdown';

import { messages } from './messages';

const iconStyles = xcss({
	backgroundColor: 'color.background.neutral',
	borderRadius: 'border.radius.050',
	width: '24px',
	height: '24px',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
});

const subheadingTextWrapper = xcss({
	marginRight: 'space.100',
});

export const MimicQuery = () => {
	const intl = useIntl();

	const [inputQuery] = useInputQuery();
	const { triggerSearch } = useSearchActions();
	const { setShowDropdown } = useDropdownActions();

	return (
		<>
			{inputQuery.length > 0 && (
				<SearchLink
					title={inputQuery}
					subheading={
						<>
							<Box xcss={subheadingTextWrapper}>{intl.formatMessage(messages.search)}</Box>
							<SquareReturnIcon />
						</>
					}
					icon={
						<Box xcss={iconStyles}>
							<SearchIcon
								color="currentColor"
								label={intl.formatMessage(messages.searchIconLabel)}
							/>
						</Box>
					}
					onClick={() => {
						setShowDropdown(false);
						triggerSearch();
					}}
				/>
			)}
		</>
	);
};
